import { render, staticRenderFns } from "./PublicProjectCalendar.vue?vue&type=template&id=dacc4eba&"
import script from "./PublicProjectCalendar.vue?vue&type=script&lang=ts&"
export * from "./PublicProjectCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports